<div [class.hide-in-print]="state.printOverview">
  <div>
    <router-outlet></router-outlet>
    <app-asset-transitioner></app-asset-transitioner>
    <app-picflow-badge *ngIf="showPicflowBranding && !atBottom && !onAssetPage" [tenantId]="tenant.id" [@picflowBadge]>
    </app-picflow-badge>
  </div>

  <app-upload-info></app-upload-info>
  <app-archive-download-info></app-archive-download-info>
</div>
<app-print-overview *ngIf="state.printOverview" class="print"></app-print-overview>
